@if (currentPage == 'orgLocationUK') {
  <div class="col-xs-12 grbno logindocUK">
  {{paracontent}}</div>
} @else {
  @if(currentPage == 'allProductsPage'){
    @if (isUserLoggedIn && componentData?.uid === 'productPageJobCodeComponent') {
      <div class="referencesContainerHomeUK grbnumber margin-B20">{{paracontent}}</div>
    }
    @if (!isUserLoggedIn && componentData?.uid === 'LOproductPageJobCodeComponent') {
      <div class="referencesContainerHomeUK grbnumber margin-B20">{{paracontent}}</div>
    }
  }
  @else{
  <div class="referencesContainerHomeUK grbnumber margin-B20" [ngClass]="currentPage == 'account'?'dashboard_docno':''">{{paracontent}}</div>
}
}
